import * as React from "react";
import {ThemeProvider} from "@emotion/react";
import {themeGh} from "@web2/themes";

export const GhThemeProvider: React.FC<{children?: React.ReactNode}> = (props) => {
    return <ThemeProvider theme={themeGh}>{props.children}</ThemeProvider>;
};
